/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriverObservationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Record one scraped driver and car observation
     * Requires driver-observations.write and a NOMADE_ENCODER JWT. The contract is taken from the authenticated application. This observation does not establish which car appears in any VOD.
     * @returns any Canonical driver state after ingestion. Repeated unchanged polls extend last_seen_at without creating a row; recorded is false when the incoming point was merged into an earlier state.
     * @throws ApiError
     */
    public driverObservationsControllerPost({
        requestBody,
    }: {
        requestBody: {
            /**
             * Car number as printed by the statistics source; leading zeros are preserved.
             */
            car_number: string;
            driver_name: string;
            /**
             * Absolute observation time with UTC offset.
             */
            observed_at: string;
        },
    }): CancelablePromise<{
        /**
         * Decimal observation identifier.
         */
        id: string;
        contract_id: number;
        car_number: string;
        driver_name: string;
        observed_at: string;
        /**
         * Latest time this same driver was observed for the car.
         */
        last_seen_at: string;
        /**
         * Whether the incoming timestamp remains as a distinct change point.
         */
        recorded: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/driver-observations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Late observation conflicts with a compacted driver state.`,
            },
        });
    }
    /**
     * Get driver changes for a time range
     * Requires driver-observations.read. Returns one response for the requested time range and authenticated contract. For each car, includes the last known state before from as a baseline, then changes within the range. Baselines may be old; last_seen_at shows their latest confirmation. These are possible drivers by time only, not verified VOD-to-car matches.
     * @returns any Previous state per car and all changes in the range, ordered by time and id.
     * @throws ApiError
     */
    public driverObservationsControllerGet({
        from,
        to,
    }: {
        /**
         * Inclusive start of the UTC time range.
         */
        from: string,
        /**
         * Exclusive end of the UTC time range.
         */
        to: string,
    }): CancelablePromise<{
        items: Array<{
            id: string;
            car_number: string;
            driver_name: string;
            observed_at: string;
            /**
             * Latest time this same driver was observed for the car.
             */
            last_seen_at: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/driver-observations',
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
            },
        });
    }
}
